import { render, staticRenderFns } from "./Busy.vue?vue&type=template&id=6cf36f0f"
import script from "./Busy.vue?vue&type=script&lang=js"
export * from "./Busy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports